import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="mt-16 border-t border-background-200 bg-background-100">
      <div className="mx-auto w-full max-w-[1280px] px-4 py-12 md:px-8">
        <div className="grid grid-cols-1 gap-8 md:grid-cols-4">
          <div className="md:col-span-1">
            <Link to="/" className="flex items-center gap-2">
              <span className="flex h-9 w-9 items-center justify-center rounded-lg bg-primary-500 text-background-50">
                <i className="ri-movie-2-line text-xl" />
              </span>
              <span className="text-lg font-bold text-foreground-50">
                黄牛<span className="text-primary-500">视频</span>
              </span>
            </Link>
            <p className="mt-4 max-w-xs text-sm leading-relaxed text-foreground-400">
              高清影视视频聚合平台，汇聚电影、电视剧、综艺与影视资讯，让好内容触手可及。
            </p>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-foreground-100">内容分类</h4>
            <ul className="mt-4 space-y-3 text-sm text-foreground-400">
              <li>
                <Link to="/category/movie" className="transition-colors hover:text-primary-500">
                  电影大全
                </Link>
              </li>
              <li>
                <Link to="/category/tv" className="transition-colors hover:text-primary-500">
                  电视剧全集
                </Link>
              </li>
              <li>
                <Link to="/category/variety" className="transition-colors hover:text-primary-500">
                  综艺节目
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-foreground-100">探索发现</h4>
            <ul className="mt-4 space-y-3 text-sm text-foreground-400">
              <li>
                <Link to="/news" className="transition-colors hover:text-primary-500">
                  影视资讯
                </Link>
              </li>
              <li>
                <Link to="/search" className="transition-colors hover:text-primary-500">
                  搜索作品
                </Link>
              </li>
              <li>
                <Link to="/about" className="transition-colors hover:text-primary-500">
                  关于我们
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-foreground-100">联系方式</h4>
            <ul className="mt-4 space-y-3 text-sm text-foreground-400">
              <li className="flex items-center gap-2">
                <i className="ri-mail-line text-base text-primary-500" />
                contact@huangniuvideo.com
              </li>
              <li className="flex items-center gap-2">
                <i className="ri-customer-service-2-line text-base text-primary-500" />
                客服时间：每日 9:00 - 22:00
              </li>
              <li className="flex items-center gap-3 pt-1">
                <span className="flex h-9 w-9 items-center justify-center rounded-full bg-background-200 text-foreground-300">
                  <i className="ri-wechat-line text-lg" />
                </span>
                <span className="flex h-9 w-9 items-center justify-center rounded-full bg-background-200 text-foreground-300">
                  <i className="ri-weibo-line text-lg" />
                </span>
                <span className="flex h-9 w-9 items-center justify-center rounded-full bg-background-200 text-foreground-300">
                  <i className="ri-bilibili-line text-lg" />
                </span>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-10 flex flex-col gap-3 border-t border-background-200 pt-6 text-xs text-foreground-500 sm:flex-row sm:items-center sm:justify-between">
          <p>© 2025 黄牛视频 HUANGNIU VIDEO. 保留所有权利。</p>
          <p>本站为影视内容聚合演示站点，所有内容仅供学习交流，不提供任何形式的在线播放源。</p>
        </div>
      </div>
    </footer>
  );
}